var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentOkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 58.938,
    viewBox: "0 0 50 58.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15582",
    "data-name": "Grupo 15582",
    transform: "translate(0.022 0.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6628",
    "data-name": "Trazado 6628",
    d: "M63.475,178.283A1.923,1.923,0,0,0,62.116,175H54.423a1.923,1.923,0,1,0,0,3.846",
    transform: "translate(-46.753 -155.874)",
    fill: "#3ae161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6629",
    "data-name": "Trazado 6629",
    d: "M49.427,9.232,40.06.467,38.876,0H17.308a5.769,5.769,0,0,0-5.769,5.769v7.668a.024.024,0,0,1-.024.024H5.769A5.769,5.769,0,0,0,0,19.231v25A5.769,5.769,0,0,0,5.769,50h1.86a1.988,1.988,0,0,0,1.68-.881,1.924,1.924,0,0,0,0-2.085,1.989,1.989,0,0,0-1.68-.881H5.8a1.97,1.97,0,0,1-.731-.13,1.928,1.928,0,0,1-1.223-1.793V19.262a1.969,1.969,0,0,1,.13-.731,1.928,1.928,0,0,1,1.793-1.223h13.9a1.935,1.935,0,0,1,1.377.577l3.377,3.462a5.8,5.8,0,0,0,4.127,1.731h7.957a1.967,1.967,0,0,1,.731.13A1.928,1.928,0,0,1,38.462,25V44.231a5.769,5.769,0,0,0,11.538,0V10.553l-.573-1.321M45.273,45.847a1.924,1.924,0,0,1-2.085,0,1.988,1.988,0,0,1-.881-1.68V25a5.769,5.769,0,0,0-5.769-5.769H28.544a1.936,1.936,0,0,1-1.377-.577L23.8,15.192a5.806,5.806,0,0,0-4.127-1.731h-4.26a.024.024,0,0,1-.024-.024V5.8a1.971,1.971,0,0,1,.13-.732,1.928,1.928,0,0,1,1.793-1.223H37.419l.028,4.977a2.619,2.619,0,0,0,2.619,2.6h6.087v32.74a1.988,1.988,0,0,1-.881,1.68",
    transform: "translate(-0.022 -0.104)",
    fill: "#3ae161"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-2",
    transform: "translate(20.835 45.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_871",
    "data-name": "Trazado 871",
    d: "M1,6.043,3.029,8.072,8.1,3",
    transform: "translate(-1 -3)",
    fill: "none",
    stroke: "#3ae161",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_427",
    "data-name": "Elipse 427",
    transform: "translate(12.847 35.756)",
    fill: "none",
    stroke: "#3ae161",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.538,
    cy: 11.538,
    r: 11.538,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.538,
    cy: 11.538,
    r: 10.038,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentOkIcon);
export default __webpack_public_path__ + "static/media/sentOkIcon.d354a9c8ec3bcfb265ad6deebf5d69f5.svg";
export { ForwardRef as ReactComponent };